import React from 'react'
import Icon from '../Icon/Icon.tsx'
import Typography from '../Typography/Typography.tsx'
import styles from './style.ts'

type SearchableInputOptionType = {
    value?: any
    text?: React.ReactNode
    title?: boolean
    selected?: boolean
    icon?: string
    disabled?: boolean
}

interface Props {
    options: SearchableInputOptionType[]
    selectedValue: any
    onSelect(item: SearchableInputOptionType): void
    menuClasses: Record<string, string>
    testId: string
}

/**
 *
 */
const SearchableMenu = ({
    options,
    selectedValue,
    onSelect,
    menuClasses,
    testId
}: Props): JSX.Element => {
    return (
        <>
            {options.map((item, index) => {
                const isSelected = item.value && item.value === selectedValue

                return (
                    <div
                        key={item.value}
                        onMouseDown={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                        }}
                        onClick={() => onSelect(item)}
                        className={`
                            ${item.title ? menuClasses.dropdownTitle : menuClasses.dropdownItem}
                            ${item.disabled ? menuClasses.dropdownDisabled : ''}
                            ${isSelected ? menuClasses.selectedItem : ''}
                        `}
                        style={{
                            ...styles.dropdownItem,
                            borderTop: item.title && index > 0 ? '1px solid #D9D8D8' : 'none',
                            borderBottom: index === options.length - 1 ? 'none' : undefined
                        }}
                        data-testid={`${testId}-item-${index}`}
                    >
                        <div style={styles.optionText}>
                            {item.text}
                        </div>
                        {isSelected && (
                            <div style={{ paddingRight: '10px' }}>
                                <Icon name='check' color='neutral-700' size={20} />
                            </div>
                        )}
                    </div>
                )
            })}
            {!options?.length && (
                <div className={menuClasses.noData}>
                    <Typography variant='subtitle3'>No data available</Typography>
                </div>
            )}
        </>
    )
}

export default SearchableMenu
